import * as React from 'react';

const NoMatch = (() => (
  <div>
    <h1>PAGE NOT FOUND</h1>
  </div>
));

export default NoMatch;
